import { InputSizes } from '@shared/ui/kit/input/model/types';
import { colors } from '@shared/tokens/colors.stylex';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';

type ChevronDownProps = {
  size: InputSizes;
  isOpenOptions: boolean;
};

const ChevronDownIcon = (props: ChevronDownProps) => {
  const { size, isOpenOptions } = props;
  return (
    <svg
      {...stylex.props(styles[size], styles.arrowTransition(isOpenOptions))}
      fill="none"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        style={{
          stroke: colors.primaryIcon,
        }}
        d="M13 5.5L8 10.5L3 5.5"
        strokeOpacity="0.7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ChevronDownIcon;
